import {Grid} from '@material-ui/core';
import {TextBox} from '../../../Core/UI';
import React, {useEffect} from 'react';
import {Prequal} from '../../../Core/mobx/ParameterStore/Prequal';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/PrequalXref';

type UpsellOpportunitiesProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
};

const UpsellOpportunities = observer(({valueChanged, parameters, setCategory, index}: UpsellOpportunitiesProps) => {
    return (
        <CategoryCard title={'Upsell Opportunities'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id={'interestedInAdditionalPolicy'}
                    label={'Additional Policies'}
                    value={parameters.interestedInAdditionalPolicy.value}
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id={'upsellMaritalStatus'}
                    label={'Marital Status'}
                    value={parameters.upsellMaritalStatus.value}
                    disabled
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Children',
                        name: 'kidsNumber',
                        options: fieldOptions.kidsNumber.options,
                        ...parameters.kidsNumber,
                    }}
                    required={''}
                    valueChanged={valueChanged}
                    disabled
                />
            </Grid>
        </CategoryCard>
    );
});

export default UpsellOpportunities;
